import { createContext, useContext, type ReactNode } from "react";

import { useClientType } from "../../shared/hooks/use-client-type";
import {
  EMPTY_CREATE_APPLICATION_DICTIONARIES,
  type CreateApplicationDictionaries,
} from "../create-application-page/create-application-dictionaries.lib";
import { useApplicationDictionaries } from "../../shared/hooks/use-application-dictionaries";

type ApplicationDictionariesContextValue = {
  dictionaries: CreateApplicationDictionaries;
  isLoading: boolean;
  isError: boolean;
};

const ApplicationDictionariesContext = createContext<ApplicationDictionariesContextValue>({
  dictionaries: EMPTY_CREATE_APPLICATION_DICTIONARIES,
  isLoading: true,
  isError: false,
});

export const ApplicationDictionariesProvider = ({ children }: { children: ReactNode }) => {
  const clientType = useClientType();
  const value = useApplicationDictionaries(clientType);

  return <ApplicationDictionariesContext.Provider value={value}>{children}</ApplicationDictionariesContext.Provider>;
};

export const useApplicationDictionariesContext = () => useContext(ApplicationDictionariesContext);
